export default import.meta.ROLLDOWN_FILE_URL_6kssa3xCT2YlMpIbbRNP$Q